import { paths } from 'api/schema';
import { Client } from 'openapi-fetch';
import { useContext } from 'react';

import { ApiClientContext } from './ApiClientContext';
export function useApiClient() {
  return useContext(ApiClientContext);
}
export type ApiClient = Client<paths>;
